// extracted by mini-css-extract-plugin
export default {"reveal":"Reveal_reveal__SPBeB","revealIn":"Reveal_revealIn__-7aFp"};